import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { CellRegionPicker } from "@/components/auth/cell-region-picker";

const regionSearchSchema = z.object({
  next: z.string().optional(),
});

export const Route = createFileRoute("/region")({
  validateSearch: (search) => regionSearchSchema.parse(search),
  component: BrowserRegionRoute,
});

function BrowserRegionRoute() {
  const { next } = Route.useSearch();

  return (
    <main className="min-h-screen flex flex-col items-stretch bg-background">
      <div className="flex justify-center pt-12 pb-4">
        <img src="/deflow.png" alt="Deflow logo" width={180} height={37} />
      </div>
      <CellRegionPicker nextPathCandidate={next} />
    </main>
  );
}
